/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ModelNameQueryOperator extends models.QueryOperator {
    constructor() {
        super();
        this.setDiscriminator("ModelNameQueryOperator");
    }

    getFixupPrototypeFunction() { return ModelNameQueryOperator.fixupPrototype; }

    static newInstance(model: Partial<ModelNameQueryOperator>): ModelNameQueryOperator {
        let obj = Object.assign(new ModelNameQueryOperator(), model);
        ModelNameQueryOperator.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ModelNameQueryOperator>): ModelNameQueryOperator {
        if (!model) return null;
        return ModelNameQueryOperator.newInstance(<ModelNameQueryOperator> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ModelNameQueryOperator) {
        if (!obj) return;

        models.ModelNameQueryOperator.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ModelNameQueryOperator): boolean {
        if (models.QueryOperator.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, ModelNameQueryOperator.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
    }

    /**
     * Model names to include; resolved server-side to matching model IDs
     */
    model_names: Array<string>;

}
